// This is the endpoints that are used in the application
// It is used in the query/mutation and will be fixed to the base url
// i.e {BASE_URL}/users
export enum ENDPOINT {
  USER = '/user',
  POSTS = '/posts',
  DISCLOSURES = '/disclosure',
  CONTRIBUTORS = '/contributor',
  HOD = '/hod',
  DEAN = '/dean',
  DRD = '/drd',
  FILE = '/file',
  TTO_DIRECTOR = '/tto-director',
  ASSESSMENT = '/assessment',
  FACULTY = '/faculty',
  CONTACT = '/contact',
  CASE = '/case',
  LICENSEE = '/licensee',
  LICENSE = '/license',
  PATENT = '/patent',
  FORMS = '/forms',
}

export enum TAG_ID {
  PARTIAL_LIST = 'PARTIAL-LIST',
  LIST = 'LIST',
}

export const TAG_TYPES: readonly string[] = Object.values(ENDPOINT);
